import Vue from 'vue';

export const TOKEN_EXPIRED_EVENT = 'token-expired';

export const EventEmitter = new Vue();

export default EventEmitter;
